import TviConnect from './TviConnect'

export default TviConnect
